import { FieldsType } from '@systemeio/digital-store-shared'
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields'
import { useEffect } from 'react'
import { InitFieldsInterface } from '../components/contact-fields'

type ArgsType = {
  savedFields: FieldsType[]
  onChange: (fields: FieldsType[]) => void
  initFields?: InitFieldsInterface[]
}

export const useStoreContactFields = ({ savedFields, onChange, initFields }: ArgsType) => {
  const { fields } = useContactFields()

  const isReady = !!fields

  useEffect(() => {
    if (fields && savedFields.length === 0) {
      const newFields: FieldsType[] = []
      fields.items.forEach(f => {
        const initField = initFields?.find(initField => initField.slug === f.slug)
        if (initField) {
          newFields.push({
            fieldName: f.fieldName,
            slug: f.slug,
            required: initField.required,
          })
        }
      })
      onChange(newFields)
    }
  }, [fields, initFields, savedFields.length])

  const availableFields = fields?.items.filter(
    field => !savedFields.some(initField => initField.slug === field.slug),
  )

  return { availableFields, isReady }
}
